module.exports = __webpack_public_path__ + "img/ACC.b805503c.png";